import React, { useEffect } from 'react';
import {
  KompisSheetBody,
  KompisSheetBodyPadding,
  KompisSheetFooter,
  KompisSheetFooterButtons,
  KompisSheetHeader
} from '@inter-ikea-kompis/react-components';
import styled from 'styled-components';
import media from 'ui/media';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Title from 'ui/Typography/Title';
import { useSelector } from 'react-redux';
import {
  helpLinesCollisionWarningSheetVisible,
  showHelpLinesCollisionWarningSheet
} from 'ducks/helpLines';
import SlideOutMenu from 'components/SlideOutMenu/SlideOutMenu';
import Box from 'ui/Box';
import { useIntl } from 'react-intl';
import { useAppDispatch } from 'ducks/hooks';
import { reportSlantedWallSpaceExceededSheet } from 'analytics/reporters';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

const TitleWrapper = styled.div`
  ${media.mobile`
    width: 100%;
    padding: 0.5rem 0;
  `}
`;

const HelpLinesCollisionWarningMenu = () => {
  const dispatch = useAppDispatch();
  const visible = useSelector(helpLinesCollisionWarningSheetVisible);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (visible) {
      reportSlantedWallSpaceExceededSheet();
    }
  }, [visible]);

  const onClose = () => {
    dispatch(showHelpLinesCollisionWarningSheet(false));
  };

  return (
    <SlideOutMenu data-testid="questions-handles-sheet" trigger={!!visible}>
      <Box style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <KompisSheetHeader theme={SkapaTheme} onCloseButtonClick={onClose} heading="" />
        <KompisSheetBody theme={SkapaTheme}>
          <KompisSheetBodyPadding theme={SkapaTheme}>
            <TitleWrapper>
              <Title pb="s" type={ThemeFontStyleTypeEnum.headingMedium}>
                {formatMessage({ id: 'storageone.helpLinesCollisionWarningHeading' })}
              </Title>
            </TitleWrapper>
            <Body py="md" mb="xxxl" type={ThemeFontStyleTypeEnum.bodyMedium}>
              {formatMessage({ id: 'storageone.helpLinesCollisionWarningInfo' })}
            </Body>
          </KompisSheetBodyPadding>
        </KompisSheetBody>
        <KompisSheetFooter theme={SkapaTheme}>
          <KompisSheetFooterButtons
            compact={false}
            data-testid="question-sheet-footer-buttons"
            theme={SkapaTheme}
            primaryLabel={formatMessage({
              id: 'storageone.helpLinesCollisionWarningButtonRemoveFrames'
            })}
            onButtonClick={() => {
              dispatch(showHelpLinesCollisionWarningSheet(false));
            }}
          />
        </KompisSheetFooter>
      </Box>
    </SlideOutMenu>
  );
};

export default HelpLinesCollisionWarningMenu;
